module.exports = __webpack_public_path__ + "img/callisto.40dbe626.png";